<!-- <h2 mat-dialog-title>
    {{title}}
</h2> -->

<mat-dialog-content class="map-section" >
    <div >
        <lib-ngx-image-zoom 
            [zoomMode]="'click'"
            [thumbImage]="mapPath"
            [magnification]="2"
            [enableScrollZoom]="true">
        </lib-ngx-image-zoom>
    </div>

    <!-- <img [src]="mapPath" style="max-width: 700px; max-height: 900px;"> -->
</mat-dialog-content>
<mat-dialog-actions align="end" >
    <div style="margin-right: 350px;">
        Click to Zoom
    </div>
    <div>
        <button mat-mini-fab 
        color="accent"
        (click)="closeDialog()">
        <mat-icon>
            close
        </mat-icon>
        </button>
    </div>
</mat-dialog-actions>
